import { Type } from "class-transformer";
import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";
import Invitation from "./invitation";
export default class User {
  id: string;
  userRoleId?: string;
  providerKind?: string;
  username: string;
  lastName?: string;
  firstName?: string;
  email: string;
  isActive: boolean;
  phoneNumber: string;
  searchText?: string;
  @observable
  @Type(() => Invitation)
  invitation?: Invitation;
}

export const BaseUserValidationRules: EntityValidationRules<User> = {
  firstName: {
    required: true,
  },
  lastName: {
    required: true,
  },
  email: {
    required: true,
    isEmail: {},
  },
  phoneNumber: {
    required: true,
    isPhoneNumber: {
      formatted: false,
    },
  },
};

export const UserValidationRules: EntityValidationRules<User> = {
  searchText: {
    isLength: {
      max: 254,
    },
  },
};

export const InternalUserValidationRules: EntityValidationRules<User> = {
  ...BaseUserValidationRules,
  username: {
    required: true,
  },
};
